import React from 'react';
import { Trans } from 'react-i18next';
import { Url } from '@wix/da-url';
import s from './CommentForAnonymous.scss';
var CommentForAnonymous = function () {
    return (React.createElement("div", { className: s.root },
        React.createElement(Trans, { i18nKey: "commentbox.anonymous.message", parent: "span" },
            React.createElement("a", { href: Url.joinLink(), className: s.link }, "Join the community"),
            ' to add your comment. Already a deviant? ',
            React.createElement("a", { href: Url.loginLink(), className: s.link }, "Sign In"))));
};
CommentForAnonymous.displayName = 'CommentForAnonymous';
export default CommentForAnonymous;
//# sourceMappingURL=CommentForAnonymous.js.map